// ==================== EMAIL TEMPLATES ====================

class EmailNotificationApi {
  // Récupérer tous les templates
  async getAllTemplates(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération des templates:', error);
      throw error;
    }
  }

  // Récupérer un template par ID
  async getTemplateById(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates/${id}`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération du template:', error);
      throw error;
    }
  }

  // Créer un nouveau template
  async createTemplate(templateData, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify(templateData),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la création du template:', error);
      throw error;
    }
  }

  // Mettre à jour un template
  async updateTemplate(id, templateData, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates/${id}`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify(templateData),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du template:', error);
      throw error;
    }
  }

  // Supprimer un template
  async deleteTemplate(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates/${id}`;
    
    try {
      const response = await fetch(URL, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la suppression du template:', error);
      throw error;
    }
  }

  // Activer/désactiver un template
  async toggleTemplateStatus(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/templates/${id}/toggle-status`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors du changement de statut du template:', error);
      throw error;
    }
  }

  // ==================== EMAIL NOTIFICATIONS ====================

  // Créer une notification
  async createNotification(notificationData, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify(notificationData),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la création de la notification:', error);
      throw error;
    }
  }

  // Récupérer les notifications en attente
  async getPendingNotifications(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications/pending`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications en attente:', error);
      throw error;
    }
  }

  // Récupérer les statistiques
  async getNotificationStats(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications/stats`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  }

  // ==================== ENVOI MANUEL D'EMAILS ====================

  // Envoyer un email à un apprenant
  async sendEmailToApprenant(templateId, customerId, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/send-to-apprenant`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify({
          template_id: templateId,
          customer_id: customerId
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email à l\'apprenant:', error);
      throw error;
    }
  }

  // Envoyer des emails à une session
  async sendEmailToSession(templateId, learnerSessionIds, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/send-to-session`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        body: JSON.stringify({
          template_id: templateId,
          learner_session_ids: learnerSessionIds
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de l\'envoi des emails à la session:', error);
      throw error;
    }
  }

  // ==================== NOTIFICATIONS PROGRAMMÉES ====================

  // Générer les notifications programmées
  async generateScheduledNotifications(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/generate-scheduled`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la génération des notifications:', error);
      throw error;
    }
  }

  // Traiter les notifications programmées
  async processScheduledNotifications(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/process-scheduled`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors du traitement des notifications:', error);
      throw error;
    }
  }

  // Récupérer l'historique des notifications
  async getNotificationHistory(params = {}, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications/history`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'historique:', error);
      throw error;
    }
  }

  // Récupérer les notifications échouées pour retry
  async getFailedNotificationsForRetry(accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications/retry-failed`;
    
    try {
      const response = await fetch(URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications échouées:', error);
      throw error;
    }
  }

  // Retenter l'envoi d'une notification
  async retryNotification(id, accessToken) {
    const URL = `${process.env.REACT_APP_API_URL}/api/email-notifications/notifications/${id}/retry`;
    
    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      
      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Erreur lors du retry de la notification:', error);
      throw error;
    }
  }
}

export const emailNotificationApi = new EmailNotificationApi(); 